import { render, staticRenderFns } from "./ServiceInPromotion.vue?vue&type=template&id=0594400e&"
import script from "./ServiceInPromotion.vue?vue&type=script&lang=js&"
export * from "./ServiceInPromotion.vue?vue&type=script&lang=js&"
import style0 from "./ServiceInPromotion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports